import React from "react";
import { FieldProps } from "formik";
import cx from "clsx";

type TRadioOption = {
  value: string;
  label: string;
};

interface RadioGroupProps extends FieldProps {
  label?: string;
  options: TRadioOption[];
}

export default ({ label, options = [], field, form }: RadioGroupProps) => {
  const touched = form.touched[field.name];
  const error = form.errors[field.name];

  return (
    <div className="form-group">
      {label && <label className={cx("control-label", touched && error && "text-danger")}>{label}</label>}

      {options.map(({ value, label }, key) => (
        <div key={key} className="ml-2">
          <div style={{ display: "inline-block" }} className="custom-control custom-radio">
            <input
              id={value}
              type="radio"
              className="custom-control-input"
              checked={field.value == value}
              onChange={() => form.setFieldValue(field.name, value)}
              onBlur={() => form.setFieldTouched(field.name, true)}
            />
            <label htmlFor={value} className="custom-control-label">
              {label}
            </label>
          </div>
        </div>
      ))}
    </div>
  );
};
